import React, { Component } from 'react';
import { Card, Badge } from 'react-bootstrap';

import './Styles.css';

class ReceptorTaxInfoCard extends Component {
  render() {
    const { data = {} } = this.props;

    return (
      <Card>
        <Card.Body>
          <strong className="text-info card-label-info">ID: </strong>
          {data.id}
          <br />

          <strong className="text-info card-label-info">Razón social: </strong>
          {data.razon_social}
          <br />

          <strong className="text-info card-label-info">RFC: </strong>
          {data.rfc}
          <br />

          <strong className="text-info card-label-info">Uso CFDI: </strong>
          {data.uso_cfdi || '...'}
          <br />

          {data?.sector_primario && data?.sector_primario_is_adquiriente && (
            <>
              <Badge variant="primary">sector primario</Badge>

              <Badge variant="primary" className="ml-2">
                adquiriente
              </Badge>
            </>
          )}
        </Card.Body>
      </Card>
    );
  }
}

export default ReceptorTaxInfoCard;
